/**
 * Часы режима работы рабочего места — «Продолжительность смены, часов» и «Часов в неделю»
 * (fractional-work-hours, заказчица 15.10.2026: «нужно дать возможность вносить дробные числа,
 * они там бывают»). Одно правило для формы места структуры и карточки места в заказе СОУТ —
 * зеркало бэкенда `domain.ValidWorkHours`: число больше 0, не более двух знаков после запятой,
 * не больше 9999,99 (техническая граница колонки numeric(6,2)).
 *
 * Ввод — по-русски с запятой («7,5»), точка тоже принимается («7.5»); пробелы по краям
 * отбрасываются. Показ — с запятой.
 */

/** Техническая граница значения — колонка `workplaces.shift_hours/week_hours` numeric(6,2). */
export const WORK_HOURS_MAX = 9999.99

/** Сообщение о недопустимом вводе — одно для обеих форм. */
export const WORK_HOURS_ERROR = 'Число больше 0, не более двух знаков после запятой'

/** Целая часть и до двух знаков после запятой или точки: «8», «7,5», «39.75». */
const WORK_HOURS_RE = /^\d+(?:[.,]\d{1,2})?$/

/**
 * Разбор ввода часов. Пустая строка — `null` (поле не заполнено; обязательность решает форма).
 * Недопустимый ввод — `NaN`. Иначе — число, округлённое до сотых (без двоичного «хвоста»).
 * Ноль возвращается числом 0 — «больше нуля» проверяет `isValidWorkHours`.
 */
export function parseWorkHours(raw: string): number | null {
  const s = raw.trim()
  if (s === '') return null
  if (!WORK_HOURS_RE.test(s)) return Number.NaN
  return Math.round(Number(s.replace(',', '.')) * 100) / 100
}

/** Значение часов допустимо: больше 0 и не больше технической границы (сотые — по разбору). */
export function isValidWorkHours(n: number | null): n is number {
  return n !== null && Number.isFinite(n) && n > 0 && n <= WORK_HOURS_MAX
}

/** Показ часов: «8», «7,5», «39,75»; отсутствующее или не больше нуля — пустая строка. */
export function formatWorkHours(n: number | null | undefined): string {
  if (n == null || !(n > 0)) return ''
  return String(Math.round(n * 100) / 100).replace('.', ',')
}
